module.exports = __webpack_public_path__ + "static/mujeres004.thumb-6f8033e384bc86e000fa52edb99e6407.jpg";